import React from "react";

import MarkdownHelper from '../../utils/MarkdownHelper';
import ReactMarkdown from 'react-markdown';

import Flag from '../../subcomponents/Flag';
import Logo from '../../subcomponents/Logo';
import { useSuperscript } from "../../utils/SuperscriptHelper";
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const TeaserAppStreamBasic = props => {
    const label_teaser_topic = useSuperscript(props.campaign.label_teaser_topic, true)
    const main_benefit_components_web = useSuperscript(props.campaign.main_benefit_components_web, true)
    const title_2_web_short = useSuperscript(props.campaign.title_2_web_short, true)
    const flagstoerer = useSuperscript(props.campaign.flagstoerer, true)
    const title_3_long = useSuperscript(props.campaign.title_3_long, true)

    const hasFlag = ['Alle', 'App Teaser'].some(val => props.flagFilter.includes(val))

    const renderTeaserAppStreamBasic = (
        <div className="ad-cp-teaser-app-stream-basic bg-white border">

            <div className="ad-cp-teaser-app-stream-basic__image-wrapper">
                {hasFlag && <Flag text={flagstoerer} appearance={props.campaign.flageye_catcher} />}

                <img className="ad-cp-teaser-app-stream-basic__image img-fluid"
                    src={props.campaign.image_3_2}
                    alt="" />
            </div>
            <div className="ad-cp-teaser-app-stream-basic-content">
                {props.logoFilter.includes('App Logo verbergen') ? '' : (<div className="teaser-logo"> <Logo logo={props.partnerLogo} format="narrow" teaserClass="teaser-logo" /></div>)}
                {label_teaser_topic ?
                    (<div className={`ad-cp-teaser-app-stream-basic__image-label-wrapper align-items-center teaser-label ${props.logoFilter.includes('App Logo verbergen') ? 'ad-cp-teaser-app-stream-basic__image-margin' : ''}`}>
                        {label_teaser_topic}
                    </div>) : null}
                {title_3_long ?
                    (<div className={`ad-cp-teaser-app-stream-basic__title-2-short ${props.campaign.title_3_long ? 'ad-cp-teaser-app-stream-basic__title-2-short-main-benefit' : ''}`}>
                        <ReactMarkdown {...MarkdownHelper.headingTypes()}
                            source={title_3_long}
                            escapeHtml={false} />
                    </div>) : null}
                {main_benefit_components_web ?
                    (<div className="ad-cp-teaser-app-stream-basic__title-4-short">
                        <ReactMarkdown {...MarkdownHelper.basicTypes()}
                            source={MarkdownHelper.parse(title_2_web_short)}
                            escapeHtml={false} />
                    </div>) : null
                }
            </div>

        </div>
    )

    return (
        <div className="app-type app-spacers">
            <div className="app-view mb-md">
                {renderTeaserAppStreamBasic}
            </div>
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </div>
    )

}

export default TeaserAppStreamBasic;


// WEBPACK FOOTER //
// ./src/components/ads/app/TeaserAppStreamBasic.js